import React from 'react';
import { Link } from 'react-router-dom';
import { ApplyNavbar } from '../../components/apply/ApplyNavbar';

export function ApplyIndexPage() {
  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(180deg,#180f16 0%,#1e1220 34%,#241525 100%)' }}>
      <ApplyNavbar />
      <section className="hero">
        <div className="container hero-grid">
          <div className="hero-copy-wrap">
            <span className="badge">全国首届祖孙隔代歌唱大赛</span>
            <h1>左三圈 右三圈，<br />祖孙一起<span className="gradient">扭起来</span></h1>
            <p className="lead">
              以经典歌曲《健康歌》为纽带，让祖辈与孙辈用歌声重新连接。这不是一场普通的比赛，而是一场跨越年龄、连接亲情、传递健康与快乐的全国性家庭音乐行动。
            </p>
            <div className="actions">
              <Link to="/apply/register" className="btn primary">立即报名</Link>
              <a href="#about" className="btn secondary">了解赛事详情</a>
            </div>

            <div className="hero-mini-stats">
              <div className="mini-stat">
                <strong>50+</strong>
                <span>祖辈参赛年龄</span>
              </div>
              <div className="mini-stat">
                <strong>3–16</strong>
                <span>孙辈参赛年龄</span>
              </div>
              <div className="mini-stat">
                <strong>60–180s</strong>
                <span>视频建议时长</span>
              </div>
            </div>
          </div>

          <div className="hero-stage">
            <div className="spot spot-a"></div>
            <div className="spot spot-b"></div>
            <div className="stage-arch"></div>
            <div className="music-float music-1">♪</div>
            <div className="music-float music-2">♫</div>
            <div className="music-float music-3">♬</div>

            <div className="character-group">
              <div className="char grand">
                <div className="head"></div>
                <div className="body"></div>
                <div className="arm left"></div>
                <div className="arm right"></div>
                <div className="mic"></div>
              </div>
              <div className="char child">
                <div className="head"></div>
                <div className="body"></div>
                <div className="arm left"></div>
                <div className="arm right"></div>
                <div className="mic"></div>
              </div>
            </div>

            <div className="hero-card ribbon-card">
              <h3>让《健康歌》在新时代重新唱响</h3>
              <p>这是一场关于家庭、笑容、陪伴与舞台记忆的比赛。唱的不只是旋律，也是祖孙之间最自然的爱。</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-alt" id="about">
        <div className="container">
          <div className="section-head center">
            <span className="section-tag">项目背景</span>
            <h2>为什么是"祖孙同唱健康歌"</h2>
            <p className="section-desc">
              当中国家庭结构正在经历深刻转型，老年人口快速增长、出生人口持续走低、隔代抚育成为普遍现实，祖孙之间的互动不再只是家庭内部的小事，而是连接亲情、健康与社会温度的重要议题。
            </p>
          </div>

          <div className="cards cards-3">
            <article className="card feature-card warm-1">
              <div className="emoji">👵👧</div>
              <h3>深度老龄化与家庭小型化并行</h3>
              <p>中国家庭正加速进入"老人更多、孩子更少、结构更小"的阶段，祖辈角色日益重要。</p>
            </article>
            <article className="card feature-card warm-2">
              <div className="emoji">🏠</div>
              <h3>隔代抚育与"老漂族"困境</h3>
              <p>许多老人承担着照顾第三代的责任，却常常缺少被看见、被鼓励与被表达的舞台。</p>
            </article>
            <article className="card feature-card warm-3">
              <div className="emoji">🎤</div>
              <h3>用歌声搭建代际桥梁</h3>
              <p>通过祖孙合作演唱《健康歌》，让健康理念、家庭文化与亲情表达在唱唱跳跳中自然流动。</p>
            </article>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-head">
            <span className="section-tag">赛事信息</span>
            <h2>一眼看懂本次比赛</h2>
          </div>
          <div className="info-grid">
            <div className="info-card gradient-card">
              <h3>活动名称</h3>
              <p>"祖孙同唱健康歌"——全国首届祖孙隔代歌唱大赛</p>
            </div>
            <div className="info-card">
              <h3>活动口号</h3>
              <p>左三圈右三圈，祖孙一起扭起来</p>
            </div>
            <div className="info-card">
              <h3>参赛对象</h3>
              <p>祖辈（≥50岁）+ 孙辈（3–16岁）组合，全国范围内均可报名。</p>
            </div>
            <div className="info-card">
              <h3>参赛形式</h3>
              <p>上传祖孙共同演唱《健康歌》的视频作品，讲述属于你们的健康与亲情故事。</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-alt" id="schedule">
        <div className="container">
          <div className="section-head center">
            <span className="section-tag">赛程安排</span>
            <h2>12 周完整赛程，层层晋级</h2>
          </div>
          <div className="timeline colorful">
            <div className="timeline-item">
              <span>第 1–4 周</span>
              <div><strong>报名及作品提交</strong><p>开放报名通道，参赛者拍摄并上传祖孙演唱《健康歌》视频。</p></div>
            </div>
            <div className="timeline-item">
              <span>第 5–6 周</span>
              <div><strong>海选评审</strong><p>由专业评审团线上评选，产生全国 100 强。</p></div>
            </div>
            <div className="timeline-item">
              <span>第 7–8 周</span>
              <div><strong>大众投票</strong><p>100 强作品进入公开投票，结合专业评审打分产生 30 强。</p></div>
            </div>
            <div className="timeline-item">
              <span>第 9–10 周</span>
              <div><strong>复赛评审</strong><p>许常德老师与评审团集中点评 30 强，选出 10 强。</p></div>
            </div>
            <div className="timeline-item">
              <span>第 11–12 周</span>
              <div><strong>决赛暨颁奖典礼</strong><p>10 强祖孙组合现场展示，首席评委现场点评并颁奖。</p></div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-head center">
            <span className="section-tag">评委与评分</span>
            <h2>专业评审 + 大众互动</h2>
          </div>

          <div className="cards cards-2">
            <article className="card judge-card">
              <div className="judge-badge">首席评委</div>
              <h3>许常德先生</h3>
              <p>华语乐坛著名词作家、音乐制作人，也是经典《健康歌》的填词人。由原词作者担任首席评委，让比赛兼具权威性与情感延续。</p>
            </article>
            <article className="card score-card">
              <h3>评分维度</h3>
              <ul className="score-list">
                <li><span>30分</span> 演唱表现力</li>
                <li><span>25分</span> 祖孙默契度</li>
                <li><span>20分</span> 创意呈现</li>
                <li><span>15分</span> 亲情感染力</li>
                <li><span>10分</span> 大众投票</li>
              </ul>
            </article>
          </div>
        </div>
      </section>

      <section className="section section-alt" id="awards">
        <div className="container">
          <div className="section-head center">
            <span className="section-tag">奖励设置</span>
            <h2>不只是奖项，更是一段家庭记忆</h2>
          </div>
          <div className="cards cards-2">
            <article className="card award-main">
              <div className="award-crown">👑</div>
              <h3>冠军亮点</h3>
              <p>冠军祖孙组合将获得奖金、"新健康歌"首发演唱权、许常德亲笔签名奖杯及亲子健康旅游基金。</p>
            </article>
            <article className="card award-sub">
              <h3>亚军 / 季军 / 十佳奖 / 专项奖</h3>
              <p>设置健康大礼包、荣誉证书、签名纪念品、专项奖品等多元奖励，让舞台上的每一份陪伴都被认真珍藏。</p>
            </article>
          </div>

          <div className="cta bright">
            <h3>现在就为祖孙共同的舞台留下一份报名记录</h3>
            <p>上传你们的歌声，留下你们的故事，让更多人看见这份跨越年龄的陪伴与快乐。</p>
            <Link to="/apply/register" className="btn primary">进入报名页面</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
